module.exports = __webpack_public_path__ + "img/wu-hanrui.cf2d4acf.jpeg";